<template>
  <a class="d-flex align-items-center justify-content-between menu-item mb-1" @click="logout()" style="cursor: pointer;">
      <div class="d-flex align-items-center" >
        <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">🚪</div>
        <div class="text-white ms-3 menu-label">Logout</div>
      </div>
  </a>
</template>

<script>
import {cleanUpAfterLogout} from "@/common/login-service";
import {mapActions} from 'vuex';

export default {
  name: "LogoutMenu",

  methods: {
    ...mapActions(['setInvitee', 'setMessage']),
    logout() {
      this.setInvitee(null);
      cleanUpAfterLogout();
      localStorage.clear();
      this.setMessage('Successfully logged out.');
      this.$router.replace({name: 'HomePage'});
    }
  }
}
</script>


